import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
//import { toast } from 'react-toastify'
import { Box, Button, Grid, Typography } from '@mui/material'
import CacheAPI from 'api/orbitV1/CacheAPI'
import image from 'assets/icons/circles-design/VectorRefresh.svg'
import axios from 'axios'
import BreadcrumbsMUI from 'common/AbstractBreadcrumbs/BreadcrumbsMUI'
import { ColorBoxContent } from 'common/ui/colorBox'
import JoyrideContext from 'context/joyride/joyrideContext'
import OrbitSession from 'hooks/useCookies'
import useOrbitFlag from 'hooks/useOrbitFlag'
import { SimTable } from 'pages/SIMs/ManageSims/SimManagement'
import PropTypes from 'prop-types'

interface SimManagementProps {
  orgId?: string
}

export default function SimManagement(props: SimManagementProps) {
  const navigate = useNavigate()
  const userRole = OrbitSession.get('role')

  const [teamMembers, setTeamMembers] = useState([])
  const [, setMainTeam] = useState([])
  const joyrideContext = useContext(JoyrideContext)
  const { tourActive, setRun } = joyrideContext

  const [orgId, setOrgId] = useState('')
  useEffect(() => {
    if (props.orgId && props.orgId?.length > 0) {
      setOrgId(props.orgId)
    } else {
      setOrgId(OrbitSession.get('orgId'))
    }
  }, [props.orgId])

  useEffect(() => {
    if (tourActive) {
      setTimeout(() => {
        setRun(true)
      }, 500)
    }
  }, [])

  const getTeamMembers = React.useCallback(async () => {
    try {
      const cachedOrgDetails = await CacheAPI.getCachedOrgDetails(orgId)
      if (
        cachedOrgDetails &&
        cachedOrgDetails.data &&
        cachedOrgDetails.data.length > 0
      ) {
        setTeamMembers(cachedOrgDetails.data)
        setMainTeam(cachedOrgDetails.data)
      // Todo: Fix this
      //} else {
        //toast.error('There is no team data at the moment.')
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err?.response) {
          throw err
        }
      }
    }
  }, [orgId])

  // feature flags
  const addNewSim = useOrbitFlag('manageSims-addNewSim')
  const batchUpdate = useOrbitFlag('manageSims-batchUpdate')

  const CustomSIMManagementTools = () => {
    return (
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent='flex-end'
      >
        <Button
          onClick={() => getTeamMembers()}
          sx={{ marginRight: '16px', display: 'flex' }}
        >
          <img
            src={image}
            alt='VectorRefresh'
            style={{
              height: '20px'
            }}
          />
        </Button>
        <div id='simMgmt__migrateBtns'>
          {addNewSim && (
            <Button
              size='small'
              variant='contained'
              id='simMgmt__addNewBtn'
              sx={{ marginRight: '16px' }}
            >
              Add New
            </Button>
          )}
          {batchUpdate && (
            <Button
              variant='contained'
              size='small'
              sx={{ marginRight: '16px' }}
              id='simMgmt__batchUpdateBtn'
              onClick={() => navigate('batch-update')}
            >
              Batch Update
            </Button>
          )}
        </div>
      </Box>
    )
  }

  useEffect(() => {
    if (orgId.length > 0) {
      getTeamMembers()
    }
  }, [orgId, getTeamMembers])

  const handleCompRefresh = () => {
    getTeamMembers()
  }

  return (
    <>
      <Typography variant='h4'>Manage SIMs</Typography>
      <Grid container direction='column' spacing={2}>
        {['opsowner', 'ops'].includes(userRole) ? null : (
          <Grid item>
            <ColorBoxContent variant='white'>
              <BreadcrumbsMUI
                crumbs={[
                  {
                    route: '/app/',
                    name: 'Dashboard'
                  },
                  {
                    route: '/app/manage-sims',
                    name: 'Manage SIMs'
                  }
                ]}
              />
            </ColorBoxContent>
          </Grid>
        )}
        <Grid item>
          <ColorBoxContent>
            <SimTable
              teamMembers={teamMembers}
              pageRows={[5, 10, 15, { value: -1, label: 'All' }]}
              customToolbarComponent={<CustomSIMManagementTools />}
              refresh={handleCompRefresh}
            />
          </ColorBoxContent>
        </Grid>
      </Grid>
    </>
  )
}

SimManagement.propTypes = {
  orgId: PropTypes.string
}
